import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=826a01c6&scoped=true&"
import script from "./CustomerCard.vue?vue&type=script&lang=js&"
export * from "./CustomerCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=826a01c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826a01c6",
  null
  
)

export default component.exports